import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import {
  ChildButton,
  IconPlacement,
  TopLevelNavButton,
} from '../nav/nav.component';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent implements OnInit {
  @Input() options!: TopLevelNavButton;
  @ViewChild('popOver') popOver!: NgbPopover;
  loading = false;
  iconPlacement = IconPlacement;

  constructor() {}

  ngOnInit(): void {}

  showPopOver() {
    if (!this.popOver) {
      return;
    }
    if (this.popOver.isOpen()) {
      this.popOver.close();
    }
    this.popOver.open();
  }

  clickedButton() {
    if (!!this.options.childButtons) {
      this.showPopOver();
      return;
    }

    const action = this.options.action();
    if (action) {
      this.loading = true;
      action.subscribe({
        next: () => {
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
    }
  }

  applyChildButtonAction(btn: ChildButton) {
    const action = btn.action();
    if (action) {
      this.loading = true;
      action.subscribe({
        next: () => {
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
    }
  }
}
